import { render, staticRenderFns } from "./FavoriteLink.vue?vue&type=template&id=40fe149b&"
import script from "./FavoriteLink.vue?vue&type=script&lang=js&"
export * from "./FavoriteLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports